export const saveErrorCodes = {
    USER_NOT_AUTHORIZED_FOR_SITE: -17,
    SITE_DELETED: -10156,
    SITE_UNAVAILABLE: -10157,
    DATA_REFERENCE_MISMATCH: -10104,
    WORKSPACE_ID_MISMATCH: -10105,
    CORRUPTED_TRANSACTIONS_ERROR: -10904
}

export const saveErrors = {
    UNKNOWN_SERVER_ERROR: 'UNKNOWN_SERVER_ERROR',
    HTTP_REQUEST_ERROR: 'HTTP_REQUEST_ERROR',

    SAVE_DISABLED_IN_DOCUMENT_SERVICES: 'SAVE_DISABLED_IN_DOCUMENT_SERVICES',
    SAVE_IN_PROGRESS: 'SAVE_IN_PROGRESS',
    NOT_LOGGED_IN: 'NOT_LOGGED_IN',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    USER_NOT_AUTHORIZED_FOR_SITE: 'USER_NOT_AUTHORIZED_FOR_SITE',
    SITE_DELETED: 'SITE_DELETED',
    SITE_UNAVAILABLE: 'SITE_UNAVAILABLE',
    FAILED_TO_PARSE_REVIEW_TOKEN: 'FAILED_TO_PARSE_REVIEW_TOKEN',
    REVIEW_TOKEN_EXPIRED: 'REVIEW_TOKEN_EXPIRED',
    CONCURRENT_SAVE: 'CONCURRENT_SAVE_ERROR',
    SITE_NAME_TAKEN: 'SITE_NAME_TAKEN_ERROR',
    DUPLICATE_COMPONENTS: 'DUPLICATE_COMPONENTS',
    DATA_REFERENCE_MISMATCH: 'DATA_REFERENCE_MISMATCH',
    MISSING_CONTAINERS: 'MISSING_CONTAINERS',
    APP_CONTROLLER_REFERENCE_MISMATCH: 'APP_CONTROLLER_REFERENCE_MISMATCH',
    DESIGN_REFERENCE_MISMATCHES: 'DESIGN_REFERENCE_MISMATCHES',
    MISSING_REFERENCE: 'MISSING_REFERENCE',
    BEHAVIOR_REFERENCE_MISMATHCHES: 'BEHAVIOR_REFERENCE_MISMATHCHES',
    PROPERTY_REFERENCE_MISMATCHES: 'PROPERTY_REFERENCE_MISMATCHES',
    STYLE_REFERENCE_MISMATCHES: 'STYLE_REFERENCE_MISMATCHES',
    CONNECTION_LIST_REFERENCE_MISMATCHES: 'CONNECTION_LIST_REFERENCE_MISMATCHES',
    SITE_DESERIALIZATION_ERROR: 'SITE_DESERIALIZATION_ERROR',
    SAVE_PUBLISH_DISABLED_ON_SERVER: 'SAVE_PUBLISH_DISABLED_ON_SERVER',
    SAVE_PUBLISH_RC_FAILED_ON_SERVER: 'SAVE_PUBLISH_RC_FAILED_ON_SERVER',
    CONCURRENT_AUTO_SAVE: 'CONCURRENT_AUTO_SAVE',
    SITE_STALE_STATE_FROM_AUTO_SAVE: 'SITE_STALE_STATE_FROM_AUTO_SAVE',
    SITE_STALE_STATE_LOCAL_CHANGE: 'SITE_STALE_STATE_LOCAL_CHANGE',
    AUTOSAVE_DISABLE_FROM_SERVER: 'AUTOSAVE_DISABLE_FROM_SERVER',
    TOO_MANY_SITES_FOR_FREE_USER: 'TOO_MANY_SITES_FOR_FREE_USER',
    USER_BLOCKED_FOR_PUBLISH: 'USER_BLOCKED_FOR_PUBLISH',
    OUTDATED_LAST_TX_ID: 'OUTDATED_LAST_TX_ID',
    RC_EXISTS: 'RC_EXISTS',
    RC_ROLLED_OUT: 'RC_ROLLED_OUT',
    IDENTITY_UNKNOWN_RUNTIME_ERROR: 'IDENTITY_UNKNOWN_RUNTIME_ERROR',
    CLONE_GRID_APP_FAILED: 'CLONE_GRID_APP_FAILED',
    TOO_MANY_PAGES: 'TOO_MANY_PAGES',
    STATIC_DOWNLOAD_FAILED: 'STATIC_DOWNLOAD_FAILED',
    TRANSPORTATION_ERROR: 'TRANSPORTATION_ERROR',
    CANARY_ERROR: 'CANARY_ERROR',
    UPSTREAM_CONNECT_ERROR: 'UPSTREAM_CONNECT_ERROR',
    DEFERRED_TIMEOUT_ERROR: 'DEFERRED_TIMEOUT_ERROR',
    TOO_MANY_TRANSACTIONS: 'TOO_MANY_TRANSACTIONS',
    PUBLISH_PIPELINE_FAILED: 'PUBLISH_PIPELINE_FAILED',
    WORKSPACE_ID_MISMATCH: 'WORKSPACE_ID_MISMATCH',
    META_SITE_NAME_ALREADY_EXIST: 'META_SITE_NAME_ALREADY_EXIST',
    CORRUPTED_TRANSACTIONS_ERROR: 'CORRUPTED_TRANSACTIONS_ERROR'
}

export const clientSaveErrors = {
    SAVE_DISABLED_IN_DOCUMENT_SERVICES: -10900,
    SAVE_IN_PROGRESS: -10901,
    UNKNOWN_SERVER_ERROR: -10903,
    HTTP_REQUEST_ERROR: -10000
}

export const serverSaveErrorCodes = {
    IDENTITY_UNKNOWN_RUNTIME_ERROR: '-1888',
    TRANSPORTATION_ERROR: '-7002',
    HTTP_REQUEST_ERROR: '-74770'
}
